import React, { Component } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/es/integration/react";
import AppLoading from "expo-app-loading";

import store, { persistor } from "../../configs/store-config";
import AppInit from "../AppInit";

function withRedux(WrappedComponent) {
  const ReduxHOC = class ReduxHOC extends Component {
    // static options = WrappedComponent.options || {}

    // constructor(props) {
    //   super(props);
    //   persistor.purge();
    // }

    render() {
      return (
        <Provider store={store}>
          <PersistGate persistor={persistor} loading={<AppLoading />}>
            <AppInit>
              <WrappedComponent {...this.props} />
            </AppInit>
          </PersistGate>
        </Provider>
      );
    }
  };

  return ReduxHOC;
}

export default withRedux;
